import React, { useCallback, useEffect, useState } from 'react'
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Input,
    Flex,
    FormLabel,
    Heading,
    Text,
    useDisclosure,
    Link,
    useToast,
} from '@chakra-ui/react';
import { MultiSelect } from "react-multi-select-component";
import { AiOutlinePlusCircle, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import TeamsDetailsModal from './TeamsDetailsModal';
import { useNavigate } from 'react-router-dom';
import { setAllTeams } from '../Redux/userDetails/teamSlice';

const CreateTeam = () => {
    const [data, setData] = useState([]);
    const [teams, setTeams] = useState([]);
    const [selected, setSelected] = useState([]);
    const [createTeam, setCreateTeam] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [teamDetails, setTeamDetails] = useState({});
    const toast = useToast();
    const user = useSelector((state) => state.user.userData);
    const orgId = useSelector((state) => state.user.orgId);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getAllUsers = useCallback(() => {
        const params = {
            userId: user.userId,
            orgId
        }
        axios.get(`http://18.132.190.48:8080/api/v1/getAllUsers`, { params })
            .then((r) => {
                setData(r.data);
            })
            .catch((err) => console.log(err))
    }, [user.userId]);


    const getTeamDetails = useCallback(() => {
        axios.get(`http://18.132.190.48:8080/api/v1/getAllTeams/user?userId=${user.userId}`)
            .then((r) => {
                setTeams(r.data);
                dispatch(setAllTeams(r.data))
            })
            .catch((err) => console.log(err))
    }, [user.userId]);


    const addTeamDetails = useCallback(() => {
        axios.post(`http://18.132.190.48:8080/api/v1/team/create?userId=${user.userId}`, {
            teamName: createTeam,
            empIds: selected.map((e) => e.value)
        })
            .then(r => {
                // console.log("response added", r.config.data)
                toast({
                    position: 'top',
                    title: 'Team Created Successfully.',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                })
                setCreateTeam("");
                setSelected([]);
                getTeamDetails();
            })
            .catch(error => {
                console.log(error);
            });
    }, [user.userId, createTeam, selected, getTeamDetails, toast]);

    const handleDelete = useCallback((teamId) => {
        axios.delete(`http://18.132.190.48:8080/api/v1/team/${teamId}`)
            .then(() => {
                toast({
                    position: 'top',
                    title: 'Team deleted Successfully.',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                })
                getTeamDetails();
            })
            .catch((error) => {
                console.log(error);
            });
    }, [getTeamDetails, toast]);

    const showTeamDetails = (teamId) => {
        const team = teams.find((team) => team.teamId === teamId)
        setTeamDetails(team);
        onOpen();
    }
    useEffect(() => {
        getAllUsers();
        getTeamDetails();
    }, [getAllUsers, getTeamDetails]);
    return (
        <>
            <Box m="auto" my={"40px"} w="50%">
                <Flex>
                    <FormLabel fontWeight="bold" mt={1}>Create Team:</FormLabel>
                    <Input onChange={(e) => setCreateTeam(e.target.value)} borderRadius={"sm"} value={createTeam} type="text" placeholder='Create Team' w="400px" p={5} border="1px solid black" />
                    <Box ml={5} mt={2} cursor={"pointer"} >
                        <AiOutlinePlusCircle size="30px" onClick={addTeamDetails} />
                    </Box>
                </Flex>
                <Flex mt={10}>
                    <Text fontWeight="bold" mt={1} mr={6}>Add Users :</Text>
                    <Box w="400px" border="1px solid" borderRadius={"sm"} >
                        <MultiSelect
                            options={data.map((e) => ({ label: e.email, value: e.empId }))}
                            value={selected}
                            onChange={setSelected}
                            labelledBy="Select"
                        />
                    </Box>
                </Flex>
            </Box>
            <Box>
                <Heading textAlign="center" size="md">Existing Teams</Heading>
                <TableContainer w="50%" m="auto" mt={5}>
                    <Table >
                        <Thead>
                            <Tr>
                                <Th bgColor="lavender" py={4} textAlign={"center"} border="1px solid">Team Name</Th>
                                <Th bgColor="lavender" py={4} textAlign={"center"} border="1px solid">Update Team</Th>
                                <Th bgColor="lavender" py={4} textAlign={"center"} border="1px solid">Delete Team </Th>
                            </Tr>
                        </Thead>
                        {
                            teams?.map((e) => (
                                <Tbody key={e.teamId}>
                                    <Tr>
                                        <Td border="1px solid" textAlign={"center"} py={2} color="black" fontWeight="semibold"><Link onClick={() => showTeamDetails(e.teamId)}>{e.teamName}</Link></Td>
                                        <Td border="1px solid" textAlign={"center"} py={2}><AiFillEdit size="25px" color='blue' onClick={() => navigate(`/update/${e.teamId}?orgId=${orgId}`)} /></Td>
                                        <Td border="1px solid" textAlign={"center"} py={2}><AiFillDelete onClick={() => handleDelete(e.teamId)} size="25px" color="red" /></Td>
                                    </Tr>
                                </Tbody>
                            ))
                        }
                    </Table>
                </TableContainer>
                {teamDetails && isOpen && <TeamsDetailsModal isOpen={isOpen} team={teamDetails} onClose={onClose} />}
            </Box>
        </>
    )
}

export default CreateTeam
